var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7266 8.82925H10.7266M15.7266 12.6969H10.7266M15.7266 4.96162H10.7266M7.22656 1.09399L7.22656 18.4983M6.02656 1.09399H14.4266C16.1067 1.09399 16.9468 1.09399 17.5885 1.41015C18.153 1.68826 18.612 2.13201 18.8996 2.67781C19.2266 3.29831 19.2266 4.11059 19.2266 5.73515V13.8572C19.2266 15.4817 19.2266 16.294 18.8996 16.9145C18.612 17.4603 18.153 17.904 17.5885 18.1822C16.9468 18.4983 16.1067 18.4983 14.4266 18.4983H6.02656C4.3464 18.4983 3.50633 18.4983 2.86459 18.1822C2.3001 17.904 1.84116 17.4603 1.55354 16.9145C1.22656 16.294 1.22656 15.4817 1.22656 13.8572V5.73514C1.22656 4.11059 1.22656 3.29831 1.55354 2.67781C1.84116 2.13201 2.3001 1.68826 2.86459 1.41015C3.50633 1.09399 4.34641 1.09399 6.02656 1.09399Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon);
export default __webpack_public_path__ + "static/media/programIcon.b01c40d9adb1ee215b7ea5811a98b70e.svg";
export { ForwardRef as ReactComponent };